import type { Dict } from "./en.js";

export const nl: Dict = {
  topbar: {
    sub: "Hantavirus-updates",
    day: "DAG",
  },
  counter: {
    cases: "TOTAAL GEVALLEN",
    deceased: "OVERLEDEN",
    countries: "LANDEN",
  },
  rail: {
    filters: "FILTERS",
    strain: "VARIANT",
    vector: "VECTOR",
    country: "BETROKKEN LANDEN",
    nationality: "BETROKKEN NATIONALITEITEN",
    hint: "Bron: NOS.nl + internationale gezondheidsinstanties",
  },
  vector: {
    cruise: "Cruiseschip",
    plane: "Vliegtuig",
    none: "Lokale besmetting",
  },
  caseType: {
    detected: "Vastgesteld",
    deceased: "Overleden",
  },
  detail: {
    casesLabel: "Gemelde gevallen",
    deceasedLabel: "Overleden",
    strainLabel: "Variant",
    occurredLabel: "Voorgevallen",
    reportedLabel: "Gemeld op",
    sources: "Bronnen & referenties",
    vectorPrefix: "Verspreidingsvector:",
    coordsLabel: "Coördinaten",
  },
  timeline: {
    play: "Afspelen",
    pause: "Pauze",
  },
  empty: {
    none: "Geen meldingen op deze datum",
    select: "Klik op een marker om de melding te bekijken",
  },
  map: { fitAll: "TOON ALLES" },
  route: { openIncident: "Open melding →" },
  ticker: { label: "DAGELIJKSE UPDATE", empty: "Geen meldingen op deze datum." },
  legend: {
    btn: "LEGENDA",
    title: "LEGENDA",
    persons: "PATIËNTEN (ZIEKENHUIS)",
    vehicles: "VAARTUIGEN & VLIEGTUIGEN",
    routes: "ROUTES & DAGPUNTEN",
    country: "LAND-HIGHLIGHT",
    ill: "Bevestigd (laboratorium-positief, ziek)",
    suspected: "Verdacht (in onderzoek)",
    deceased: "Overleden",
    cleared: "Vrijgegeven (negatief getest)",
    cluster: "Cluster — tik om te splitsen bij hogere zoom",
    shipIcon: "Cruiseschip (Hondius)",
    planeIcon: "Passagiersvliegtuig",
    medevacIcon: "Medisch evacuatievliegtuig",
    ship: "Cruiseschip-route (cyaan streepjes)",
    plane: "Passagiersvlucht (gele stippen)",
    medevac: "Medische evacuatie (grijze stippen)",
    pinStep: "Dagpunt — klik voor datum + toelichting",
    pinCap: "Vertrek / huidige positie",
    countryNote: "Rood = land met actieve of bevestigde casus",
  },
  lastSync: "laatste update",
};
